import { NodeState } from "@/components/FlowSheetEditor/services/modal"
import { InfoCard } from "../InfoCard"
import { CompositionSplit } from "./CompositionSplit"
import { EditCompositionSplit } from "./EditCompositionSplit"


interface CompositionSplitCardProps {
  className?: string
  data: any
  unit: NodeState
  splitterId: string
}

export function CompositionSplitCard(props: CompositionSplitCardProps) {
  const {className, data, unit, splitterId} = props;

  return <InfoCard
    title="Compositions and split ratios"
    className={className}
    action={<EditCompositionSplit readonly={false} data={data} unit={unit} splitterId={splitterId || unit.id} />}
  >
    <CompositionSplit readonly={true} data={data} unit={unit} />
  </InfoCard>
}